import React, { useEffect, useState, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import toast from "react-hot-toast";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  TextField
} from "@material-ui/core";
import { MdEdit } from "react-icons/md";
import MappingService from "../services/MappingService";
import IssueNumberService from "../services/IssueNumberService";
import { useBrand } from "./../helper/BrandContext";

const DeMapping = ({ isLoggedIn }) => {
  const { brand } = useBrand();
  const issueNumberService = new IssueNumberService();
  const mappingService = new MappingService();
  const surveyLink = useRef(null);
  const [tableRequest, setTableRequest] = useState({
    IsActive: "1",
    PageNo: 1,
    First: 1,
    SearchValue: "",
    PageSize: 10,
    SortColumn: "CreatedDate",
    SortOrder: "DESC",
    ProductId: 0,
    WareHouseId: 0,
    UserId: sessionStorage.getItem("userId"),
    FromDate: "",
    ToDate: "",
    UserType: 0,
    IsAccepted: false,
    IsWareHouse: true,
    isAdmin: false,
    Prefix: "",
    isPreprinted: false,
    Qty: 0,
    brandId: 0
  });
  const [state, setState] = useState({
    first: 0,
    sales: [],
    loading: true,
    datasource: [],
    allData: [],
    globalFilter: "",
    emptyMessage: "No Data found",
    rows: 10,
    totalRecords: 0,
    FromDate: new Date(),
    ToDate: new Date(),
    sortOrder: "",
    shippersData: []
  });
  const navigate = useNavigate();
  const [triggerDownload, setTriggerDownload] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [formData, setFormData] = useState({
    FromNo: "",
    ToNo: "",
    issueQty: "",
    batchNo: "",
    dateManufactur: "",
    dateExpiry: "",
    itemBatchsize: "",
    serialShippingCode: "",
    Userid: tableRequest.UserId,
    brandId: 0
  });

  const [formErrors, setFormErrors] = useState({
    FromNo: "",
    ToNo: "",
    issueQty: ""
  });

  function fetchDemappingData() {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    mappingService
      .Getdemappingordamage(tableRequest)
      .then((response) => {
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
        const data = response;
        if (data && data.responseData && data.responseData.length > 0) {
          const sales = data.responseData.slice(0, tableRequest.PageSize);
          setState((prevData) => ({
            ...prevData,
            datasource: data.responseData,
            totalRecords: data.responseData[0].totalRows,
            sales,
            loading: false
          }));
        } else {
          setState((prevData) => ({
            ...prevData,
            datasource: [],
            totalRecords: 0,
            sales: [],
            loading: false
          }));
        }
      })
      .catch((error) => {
        console.error("API request failed:", error);
        toast.error("Failed to fetch data");
        setState((prevData) => ({
          ...prevData,
          loading: false
        }));
      });
  }
  const searchFilter = (e) => {
    const value = e.target.value;
    setState((prevData) => ({
      ...prevData,
      loading: false
    }));
    tableRequest.SearchValue = value;
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchDemappingData();
  };

  const getLazyLoadingValues = (event) => {
    setState((prevData) => ({
      ...prevData,
      first: event.first,
      rows: event.rows
    }));
    tableRequest.PageSize = event.rows;
    tableRequest.PageNo = Math.floor(event.first / event.rows) + 1;
    tableRequest.First = event.first + 1;
    tableRequest.IsActive = "1";
    tableRequest.SearchValue = tableRequest.SearchValue || "";
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
  };

  const onSort = (event) => {
    setState((prevData) => ({
      ...prevData,
      sortOrder: state.sortOrder === 1 ? 2 : 1
    }));
    tableRequest.SortColumn = event.sortField;
    tableRequest.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
    tableRequest.FromDate = state.FromDate;
    tableRequest.ToDate = state.ToDate;
    fetchDemappingData();
  };

  const onPage = (event) => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    getLazyLoadingValues(event);
    fetchDemappingData();
  };

  useEffect(() => {
    setState((prevData) => ({
      ...prevData,
      loading: true
    }));
    if (brand) {
      tableRequest.brandId = brand;
      const storedToken = sessionStorage.getItem("token");
      const storedUserid = sessionStorage.getItem("userId");
      setFormData((prevFormData) => ({
        ...prevFormData,
        Userid: storedUserid || "",
        brandId: brand
      }));
      if (storedToken) {
        isLoggedIn(true);
      } else {
        isLoggedIn(false);
        navigate("/login");
      }
      setState((prevData) => ({
        ...prevData,
        loading: false
      }));
      fetchDemappingData();
    }
  }, [isLoggedIn, navigate, brand]);

  useEffect(() => {
    if (triggerDownload) {
      surveyLink.current.link.click();
      setTriggerDownload(false); // Reset the trigger after download
    }
  }, [triggerDownload]);

  const handleDialogOpen = (row) => {
    const editMode = () => {
      setSelectedRow(row);
      setFormData((prevFormData) => ({
        ...prevFormData,
        FromNo: row.fromNo?.toString(),
        ToNo: row.toNo?.toString(),
        issueQty: row.qty?.toString(),
        batchNo: row.batchNo?.toString(),
        dateManufactur: row.dateManufactur?.toString(),
        dateExpiry: row.dateExpiry?.toString(),
        itemBatchsize: row.itemBatchsize?.toString(),
        serialShippingCode: row.serialShippingCode?.toString()
      }));
      setOpenDialog(true);
    };

    return (
      <Button
        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2
            rounded text-sm hover:text-white cursor-pointer"
        onClick={editMode}
      >
        <MdEdit />
      </Button>
    );
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setFormErrors({
      FromNo: "",
      ToNo: "",
      issueQty: ""
    });
  };

  const validateForm = () => {
    let valid = true;
    const errors = {
      FromNo: "",
      ToNo: "",
      issueQty: ""
    };
    const isValidFromNo =
      /^\d+$/.test(formData.FromNo) && parseInt(formData.FromNo, 10) > 0;
    errors.FromNo = isValidFromNo ? "" : "From number must be a natural number";
    if (!isValidFromNo) {
      valid = false;
    }

    const isValidIssueQty =
      /^\d+$/.test(formData.issueQty) && parseInt(formData.issueQty, 10) > 0;
    errors.issueQty = isValidIssueQty
      ? ""
      : "Issue Qty must be a natural number";
    if (!isValidIssueQty) {
      valid = false;
    }

    setFormErrors(errors);
    return valid;
  };

  const handleFormChange = (event) => {
    const { name, value } = event.target;

    // Assuming 'issueQty' and 'FromNo' are numeric values
    if (name === "issueQty") {
      const issueQty = parseFloat(value);
      const FromNo = parseFloat(formData.FromNo); // Assuming 'FromNo' is already set

      if (!isNaN(issueQty) && !isNaN(FromNo)) {
        const ToNo = FromNo + issueQty - 1;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
          ToNo: ToNo.toString() // Convert to string if necessary
        }));
        formData.issueQty = issueQty;
        formData.ToNo = ToNo.toString();
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
          ToNo: "" // Set to empty if values are invalid
        }));
      }
      formData.issueQty = value;
    } else if (name === "FromNo") {
      const FromNo = parseFloat(value);
      const qty = parseFloat(formData.issueQty); // Assuming 'FromNo' is already set

      if (!isNaN(qty) && !isNaN(FromNo)) {
        const ToNo = FromNo + qty - 1;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
          ToNo: ToNo.toString() // Convert to string if necessary
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: value,
          ToNo: "" // Set to empty if values are invalid
        }));
      }
      formData.FromNo = value;
    } else {
      setFormData({ ...formData, [name]: value });
      if (name === "FromNo" && value.length > 0) {
        formData.FromNo = value;
      }
      if (name === "issueQty" && value.length > 0) {
        formData.issueQty = value;
      }
    }
    validateForm();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      try {
        issueNumberService.CreateDemapping(formData).then((res) => {
          if (res.responseCode == "200") {
            toast.success(res.responseMessage);
          } else {
            toast.error(res.responseMessage);
          }
          setFormData((prevFormData) => ({
            ...prevFormData,
            FromNo: "",
            ToNo: "",
            issueQty: "",
            batchNo: "",
            dateManufactur: "",
            dateExpiry: "",
            itemBatchsize: "",
            serialShippingCode: ""
          }));
          handleDialogClose();
          fetchDemappingData();
        });
      } catch (error) {
        console.error("Error creating issue data:", error);
      }
    }
  };

  const header = (
    <div className="header-container p-4 bg-gray-100 rounded-lg shadow-md flex flex-col md:flex-row justify-between items-center">
      <div className="flex items-center mb-4 md:mb-0">
        <h1 className="reports_head text-2xl font-semibold text-gray-800 mr-4">
          DeMapping
        </h1>
      </div>
      <div className="search-export-container flex items-center">
        <div className="search-container flex items-center mr-4">
          <InputText
            type="search"
            onInput={searchFilter}
            value={tableRequest.SearchValue || ""}
            placeholder="Global Search"
            size="22"
            className="p-inputtext-sm"
          />
          {/* <i className="pi pi-search text-gray-500 mr-2 ml-2 text-xs"></i> */}
        </div>
      </div>
    </div>
  );

  return (
    <div className="mt-3">
      {state.loading ? (
        <Loader />
      ) : (
        <div className="container-fluid mt-3 mb-3">
          <div className="mt-3">
            <div className="container-fluid mt-3 mb-3">
              <DataTable
                exportFilename="DeMapping Report"
                responsive={true}
                header={header}
                globalFilter={state.globalFilter}
                emptyMessage={state.emptyMessage}
                value={state.sales}
                paginator={true}
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                rows={state.rows}
                rowsPerPageOptions={[10, 50, 200, 500]}
                totalRecords={state.totalRecords}
                lazy={true}
                first={state.first}
                onPage={onPage}
                onSort={onSort}
                className="p-datatable-responsive"
              >
                <Column
                  field="productName"
                  header="SKU Name"
                  sortable={false}
                  style={{ width: "100px" }}
                />
                <Column
                  field="fromNo"
                  header="From Number"
                  sortable={false}
                  style={{ width: "100px" }}
                />
                <Column
                  field="toNo"
                  header="To Number"
                  sortable={false}
                  style={{ width: "100px" }}
                />
                <Column
                  field="qty"
                  header="Issue Qty"
                  sortable={false}
                  style={{ width: "100px" }}
                />
                <Column
                  field="formattedCreatedDate"
                  header="Created Date"
                  sortable={true}
                  style={{ width: "100px" }}
                />
                <Column
                  body={handleDialogOpen}
                  header="Action"
                  sortable={false}
                  style={{ width: "100px" }}
                />
              </DataTable>
            </div>
          </div>

          <Dialog open={openDialog} onClose={handleDialogClose} className="add">
            {/* <DialogTitle></DialogTitle> */}
            <div className="modal-header">
              <h5 className="modal-title adduser">Demap</h5>
            </div>

            <form onSubmit={handleSubmit}>
              <DialogContent>
                <TextField
                  margin="dense"
                  label="From Number"
                  type="text"
                  name="FromNo"
                  value={formData.FromNo}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.FromNo}
                  helperText={formErrors.FromNo}
                />
                <TextField
                  margin="dense"
                  label="Issue Quantity"
                  type="text"
                  name="issueQty"
                  value={formData.issueQty}
                  onChange={handleFormChange}
                  fullWidth
                  error={!!formErrors.issueQty}
                  helperText={formErrors.issueQty}
                />
                <TextField
                  margin="dense"
                  label="To Number"
                  type="text"
                  name="ToNo"
                  disabled
                  value={formData.ToNo}
                  onChange={handleFormChange}
                  fullWidth
                />

                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <DialogActions>
                      <Button
                        onClick={handleDialogClose}
                        className="can bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                        type="button"
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        color="primary"
                        className=" sub bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                      >
                        Submit
                      </Button>
                    </DialogActions>
                  </div>
                </div>
              </DialogContent>
            </form>
          </Dialog>
        </div>
      )}
    </div>
  );
};

export default DeMapping;
